import React from "react";
import SearchIcon from "../../img/SearchIcon.svg"
import "./SearchButton.css";

const SearchButton = () => {

  return (
    <div className="search-button">
      <img className="shape" src={SearchIcon} alt="Search Icon" />
    </div>
  );
}

export default SearchButton;
